var exports = {
  "p$": "ResizablePaneHandles.module__handle___ZkhCeX",
  "J3": "ResizablePaneHandles.module__edgeTop___ZkhCeX",
  "xf": "ResizablePaneHandles.module__edgeBottom___ZkhCeX",
  "Ve": "ResizablePaneHandles.module__edgeLeft___ZkhCeX",
  "IW": "ResizablePaneHandles.module__edgeRight___ZkhCeX",
  "wy": "ResizablePaneHandles.module__cornerTopLeft___ZkhCeX",
  "Ty": "ResizablePaneHandles.module__cornerTopRight___ZkhCeX",
  "AU": "ResizablePaneHandles.module__cornerBottomLeft___ZkhCeX",
  "pr": "ResizablePaneHandles.module__cornerBottomRight___ZkhCeX",
};

module.exports = exports;
